import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb20d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__info" }
const _hoisted_2 = { class: "product__info--header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header__category--title" }, "Category: ", -1 /* HOISTED */))
const _hoisted_4 = { class: "header__category" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header__brand--title" }, "Brand: ", -1 /* HOISTED */))
const _hoisted_6 = { class: "header__brand" }
const _hoisted_7 = { class: "product__info--description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description__text--title" }, " Description: ", -1 /* HOISTED */))
const _hoisted_9 = { class: "description__text" }
const _hoisted_10 = { class: "product__info--return" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "return__text" }, "14 days to return the goods", -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "product__info--sale"
}

import { IProduct } from '@/services';
import { toRefs, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductInfo',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
};



const { product } = reactive(props);
const { category, brand, description, discountPercentage } = toRefs(product);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(category)), 1 /* TEXT */),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(brand)), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(description)), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrows-rotate" }),
      _hoisted_11
    ]),
    (_unref(discountPercentage))
      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Sale " + _toDisplayString(_unref(discountPercentage)) + "% ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})